import { render, staticRenderFns } from "./summary-updated.vue?vue&type=template&id=42244da9"
import script from "./summary-updated.vue?vue&type=script&lang=js"
export * from "./summary-updated.vue?vue&type=script&lang=js"
import style0 from "./summary-updated.vue?vue&type=style&index=0&id=42244da9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports